import {
    CHECK_MSV_REQUEST,
    CHECK_MSV_SUCCESS,
    CHECK_MSV_ERROR
  } from "./CheckMSVTypes";
  
  const initialState = {
    loading: false,
    error: "",
    checkMSVDetails: []
  };
  
  export default (state = initialState, action) => {
    switch (action.type) {
      case CHECK_MSV_REQUEST:
        return {
          ...state,
          loading: true
        };
      case CHECK_MSV_SUCCESS:
        // do something
        return {
          ...state,
          loading: false,
          checkMSVDetails: action.payload,
          error: ""
        };
      case CHECK_MSV_ERROR:
        return {
          ...state,
          loading: false,
          checkMSVDetails: [],
          error: action.payload
        };
      default:
        return state;
    }
  };
  